import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Box, ContentLayoutF } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { AccountCard } from './AccountCard';
import { AccountOverviewMenuCard } from './AccountOverviewMenuCard';
import { CoordinatedAccountsCard } from './CoordinatedAccountsCard';
import { FourOhOneKContributionsCard } from './FourOhOneKContributionsCard';
import { EnvelopeAccountMessagesDocument } from './graphql/query.EnvelopeAccountMessages.generated';
import { HoldingsTableCard } from './HoldingsTableCard/HoldingsTableCard';
import { IraContributionsCard } from './IraContributionsCard';
import { PortfolioStrategyCard } from './PortfolioStrategyCard';
import { RecurringTransactionsCard } from './RecurringTransactionsCard';

import MessageBox from '../../../Shared/message-box/message-box';
import { Layout } from '../../InstitutionalApp/Layout';

const Messages: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const { data } = useGraphQLQuery(EnvelopeAccountMessagesDocument, { variables: { id: accountId } });

  if (!data?.envelopeAccount?.messages) {
    return null;
  }

  return <MessageBox messages={data?.envelopeAccount.messages} />;
};

export const AccountOverview: React.FC = () => {
  const { enabled } = useFeatureFlag({
    splitName: 'retail.b4a_ax_managed_acct_contribution_details_enabled',
    context: 'AccountOverview',
  });
  return (
    <Layout active="clients">
      <Layout.Content>
        <ContentLayoutF
          css={{
            paddingTop: 'space.400',
          }}
        >
          <ContentLayoutF.SlotContainer>
            <ContentLayoutF.Slot1
              css={{
                display: 'grid',
                gap: { base: 'space.100', sm: 'space.300' },
                gridAutoRows: 'max-content',
              }}
            >
              <Messages />
              <AccountCard />
              <CoordinatedAccountsCard />
              <HoldingsTableCard />
            </ContentLayoutF.Slot1>
            <ContentLayoutF.Slot2
              css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
            >
              <Box css={{ display: 'flex', flexWrap: 'wrap', gap: 'space.300', width: '100%' }}>
                <AccountOverviewMenuCard />
                {enabled ? (
                  <>
                    <RecurringTransactionsCard />
                    <PortfolioStrategyCard />
                    <FourOhOneKContributionsCard />
                    <IraContributionsCard />
                  </>
                ) : (
                  <PortfolioStrategyCard />
                )}
              </Box>
            </ContentLayoutF.Slot2>
          </ContentLayoutF.SlotContainer>
        </ContentLayoutF>
      </Layout.Content>
    </Layout>
  );
};
